export default "__VITE_ASSET__BfnhDMGj__"